<template>
  <div>
    <pc-navbar/>
    <div class="orderCreate">
      <div class="content clearfix">
        <div class="w840 fl">
          <BlockMentor :info="cardDetailInfo" />
          <div class="formBox bg_fff service-picker">
            <div class="service">
              <!-- 1 选择服务内容 -->
              <div class="serviceTitle pr" style="padding-bottom: 16px;">
                <span class="f_18 color_40 font_w_b">选择服务内容</span>
                <div class="pa color_fff f_18 text_center">1</div>
              </div>
              
              <!-- 新 -->
              <div class="service-container">
                <!-- <div class="p-t-32 p-b-12"> -->
                <img v-if="serviceBanner && serviceBanner.image" @click="serviceBannerClick" class="banner-icon" :src="serviceBanner.image" alt="" style="margin-top: 16px;">
                <div
                  class="service-box"
                  :class="{intern:formData.plan=='intern'}" 
                  :style="{
                    transform: `translateX(${listTranslateX}px)`,
                  }"
                >
                  
                  <div class="service-item" v-for="(item,index) in serviceConfig" :key="`service-item&${index}`" @click="toggleService(item.type)">
                    <div class="service-item-header">
                      <h6>
                        {{ item.title }}
                          <img v-if="item.iconSrc" :src="item.iconSrc" alt="">
                      </h6>
                      <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content" v-html="item.descTips"></div>
                        <div class="service-item-detail">
                          详情
                        </div>
                      </el-tooltip>
                    </div>
                    
                    <p class="service-item-desc">{{ item.desc }}</p>
                    
                    <div class="service-item-footer">

                      <div class="service-item-footer-left">
                        <img :src="item.imgSrc" alt="">
                        <span>{{item.count}}用户选择</span>
                      </div>

                      <div class="service-item-footer-button" :class="formData[item.type] ? 'selected' : 'no-select'">
                        <i v-if="!formData[item.type] " class="iconfont iconxinjianjianli"></i>
                        {{ formData[item.type] ? '已选择' : '选择' }}
                      </div>

                    </div>

                  </div>
                <!-- </div> -->
                </div>
                <div
                  v-show="listTranslateX < 0"
                  class="left-arrow"
                  @click="handleClickArrow('left')"
                >
                  <i class="iconfont iconchevron-left"></i>
                </div>
                <div
                  v-show="displayRightArrow"
                  class="right-arrow"
                  @click="handleClickArrow('right')"
                >
                  <i class="iconfont iconchevron-right"></i>
                </div>
              </div>
              
              <!-- 2 补充服务条件 -->
              <div class="serviceTitle pr" style="margin-bottom: 12px;">
                <span class="f_18 color_40 font_w_b">补充服务条件</span>
                <div class="pa color_fff f_18 text_center">2</div>
              </div>
             
              <el-form :model="formData" :rules="rules" ref="newsData" class="clearfix service-form-content">
                <!-- 求职身份 -->
                <div class="formItem">
                  <div class="formTitle color_40 f_16 flex align-items-center">
                    求职身份
                    <div class="iconfont iconwenhao cursor_p pr">
                      <div class="tipsText pa color_fff f_12">注：【找实习】版优化前无语音沟通，如果你是应届生建议选择【找校招】，导师会在修改前语音深挖你的过往经历，提升简历通过率效果更佳
                      </div>
                    </div>
                  </div>
                  <el-select v-model="formData.job_identity" placeholder="请选择" class="optionBlock">
                    <el-option
                      v-for="item in JOB_IDENTITY_OPTIONS"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!-- 最高学历 -->
                <div class="formItem">
                  <div class="formTitle color_40 f_16">最高学历</div>
                  <el-select
                    v-model="formData.degree"
                    placeholder="请选择"
                    class="optionBlock"
                    :disabled="disabledOtherService"
                  >
                    <el-option
                        v-for="item in newsData.degree"
                        :key="item.name"
                        :label="item.value"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </div>
                <!-- 求职目标行业 -->
                <div class="formItem">
                  <div class="formTitle color_40 f_16">求职目标行业</div>
                  <el-select v-model="formData.industry" placeholder="请选择" class="optionBlock" @change="optionChange()">
                    <el-option
                        v-for="item in newsData.industry"
                        :key="item.name"
                        :label="item.value"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </div>
                <!-- 简历语言选择 -->
                <div class="formItem">
                  <div class="formTitle color_40 f_16">简历语言选择</div>
                  <el-select
                    v-model="formData.cv_lang"
                    placeholder="请选择"
                    class="optionBlock"
                    :disabled="!formData.cv_optimization"
                  >
                    <el-option
                        v-for="item in newsData.cv_lang"
                        :key="item.name"
                        :label="item.value"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </div>
                <!-- 是否需要加急 -->
                <div class="formItem">
                  <div class="formTitle color_40 f_16">是否需要加急</div>
                  <el-select v-model="formData.urgency" placeholder="请选择" class="optionBlock" :disabled="disabledOtherService">
                    <el-option
                        v-for="item in newsData.urgency"
                        :key="item.name"
                        :label="item.value"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </div>
                <!-- 跨专业求职 -->
                <div class="formItem">
                  <div class="formTitle color_40 f_16">转行（非本专业求职）</div>
                  <el-select v-model="formData.change_profession" placeholder="请选择" class="optionBlock" :disabled="disabledOtherService">
                    <el-option
                        v-for="item in newsData.change_profession"
                        :key="item.name"
                        :label="item.value"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </el-form>
            </div>
          </div>
          <div class="service-other">
            <div class="process">
              <div class="right-content-title">服务流程</div>
              <div class="process-item2">
                <img :src="newimage" alt="" width="135%">
              </div>
            </div>
            <div class="problem">
              <div class="problemTitle f_16 color_60 pr">如果你有以下疑问</div>
              <div class="list" v-for="(item,index) in SERVICE_FAQ" :key='index'>
                <div class='title f_14 color_40 pr ellipsis2' @click="toggleDescription(index)">
                  {{`${index + 1}.${item.title}`}}
                  <div :class="['icon pa', item.showDescription ? 'current' : '']"></div>
                </div>
                <div class="text color_9c f_14" v-html="item.descrpition" v-show="item.showDescription"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部菜单 -->
      <div class='footerBar bg_fff'>
        <div class="cont">
          <!-- 选择内容 -->
          <div class="des footerBar-left">
            <div class="name color_40 f_14">
              产品名称：<span v-if="formData.job_identity || formData.job_identity === 0" class="color_red">【{{formData.job_identity | jobIdentityFilter}}】</span>
              <span class="color_red text" v-if="formData.cv_optimization">简历优化</span>
              <span class="color_red text" v-if="formData.interview_guidance">面试辅导</span>
              <span class="color_red text" v-if="formData.resume_submission">简历代投</span>
              <span class="color_red text" v-if="formData.discount_monthly_card">特惠月卡</span>
              <span class="color_red text" v-if="formData.interview_simulation">职业咨询</span>
              <span class="color_red text" v-if="formData.career_plan">职业规划</span>
            </div>
            <div class="service flex">
              <div class='sname color_40 f_14'>服务条件：</div>
              <div class="color_60 f_12 flex1">
                <p class="newChangeCss">
                  <span v-if="degree_name">【{{degree_name}}】</span>
                  <span v-if="industry_name">【{{industry_name}}】</span>
                  <span v-if="cv_lang_name">【{{cv_lang_name}}】</span>
                  <span v-if="formData.urgency === 'normal'">【正常：3 天反馈】</span>
                  <span v-else-if="formData.urgency === '24hours'">【加急：1 天反馈】</span>
                  <span>
                    {{ formData.change_profession ? '【转行求职】' : '【非转行求职】' }}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="footerBar-right">
            <!-- 优惠券 -->
            <div class="orderCont">
              <div class="money f_16 color_40" style="margin-top:16px;" v-if="money>-1 && needGetMoney" >总计价格：<span class='f_28 color_red pr'>¥ <span>{{money}}</span><del v-if="del_price" class="del-price">{{originPrice}}</del></span></div>
              <div class="money f_16 color_40" style="margin-top:16px;" v-else >总计价格：<span class='f_28 color_red pr'>···</span></div>
              <div class="couponMoney f_14 color_red" v-if="coupons.length" @click="showCouponsAlert = true">优惠券：- ¥ {{ couponsPrice }}<i class="iconfont iconchevron-right"></i>
              </div>
              <div @click="showCouponsAlert = true" class="use_coupons" v-else>使用优惠券
                <i class="iconfont iconchevron-right"></i>
              </div>
            <div class="terms f_12" style="color:gray"><span class="cursor_p" @click="toggleServiceBg('snameState')">下单即默认同意《服务协议》</span></div>
            </div>
            <!-- 购买按钮 -->
            <div class="payButton color_fff bg_red text_center f_18" @click="formSubmit('newsData')">立即购买</div>
          </div>
        </div>
      </div>
      <!-- 背景 -->
      <div class="serviceBg" v-if="addIndustryState || snameState"></div>
      <!-- 添加自定义目标行业 -->
      <div class="addIndustry bg_fff" v-if="addIndustryState">
        <div class="title font_w_b f_18 color_40">求职目标行业</div>
        <el-input v-model="formData.custom_industry" placeholder="请填写" class="optionBlock" maxlength="15"/>
        <div class="templateButtons clearfix f_14 text_center">
          <div class="confirm fr cursor_p color_fff" :class="[!formData.custom_industry?'disabled':'']"
               @click="formData.custom_industry?toggleServiceBg('addIndustryState') : ''">确定
          </div>
          <div class="cancel fr cursor_p color_60"
               @click="formData.custom_industry=''; formData.industry=''; toggleServiceBg('addIndustryState')">取消
          </div>
        </div>
      </div>
      <!-- 添加目标行业 -->
      <div class="snameContent bg_fff" v-if="snameState">
        <div class="title f_20 color_40 text_center pr font_w_b">《导师服务协议》
          <div class="iconfont iconx pa color_90 font_w_b cursor_p" @click="toggleServiceBg('snameState')"></div>
        </div>
        <div class="textContent f_14 color_60">
          <div v-html="snameContent"></div>
        </div>

      </div>
    </div>
    <pay-mentor
      v-if="isShowPay"
      :orderId="orderId"
      :currentServiceData="serviceConfig"
      :orderReq="orderReq"
      :money="money"
      :detail="{
        job_identity_name: JOB_IDENTITY_OPTIONS.find(item => item.value === formData.job_identity) && JOB_IDENTITY_OPTIONS.find(item => item.value === formData.job_identity).label,
        degree_name,
        cv_lang_name,
        industry_name,
        urgency: (formData.urgency === 'normal' ? '正常：3 天反馈' : '加急：1 天反馈'),
        profession_name: formData.change_profession ? '转行求职': '非转行求职',
      }" 
      :orderPriceData="orderPriceData"
      @close="isShowPay=false"
    />
    <bindPhone v-if="showBindTips" @cancelBindForm='cancelBindForm' @success='success'/>
    <coupons-alert  v-if="showCouponsAlert" @close='showCouponsAlert=false' @getCouponId='getCouponId' :plan="formData.plan" :couponId='coupon.id'/>
  </div>
</template>
<script>
  import api from '@/api';
  import {mapGetters, mapActions} from 'vuex'
  import {routerTo, get_tUser, auth} from '@/assets/js/util';
  import {serviceConfig, snameContent,} from '@/assets/js/service';
  import PcNavbar from '@/components/base/navbar';
  import payMentor from "./payMentor";
  import BlockMentor from './BlockMentor';
  import bindPhone from './phone';
  import couponsAlert from './coupons';
  import {JOB_IDENTITY_OPTIONS, SERVICE_FAQ} from './const'

  const INCOMPATIBLE_KEYS = ['cv_optimization', 'interview_guidance', 'interview_simulation', 'career_plan']
  const INCOMPATIBLE_KEYS2 = ['resume_submission', 'discount_monthly_card']
  const ALL_KEYS = [...INCOMPATIBLE_KEYS, ...INCOMPATIBLE_KEYS2]
  
  export default {
    name: 'orderCreat',
    layout: 'notTop',
    data() {
      var validateIndustry = (rule, value, callback) => {
        if (!this.industry.value) {
          callback(new Error('请选择目标行业领域'));
        } else {
          callback();
        }
      };
      return {
        flag: false, // 用于点击立即购买判断是否在这绑定手机号 确定成功之后才传过来true
        showCouponsAlert:false,//优惠券弹窗
        showBindTips:false, //填写手机号
        newimage:'https://files.wondercv.com/PC/service/service_liucheng.png',//动态更换实习导师辅导页面购买图片
        _c_t: '',
        price: '', //基础价格
        JOB_IDENTITY_OPTIONS,
        SERVICE_FAQ,
        orderReq: {},
        orderPriceData: {},
        position:'',
        snameContent,
        serviceConfig,
        listTranslateX: 0,
        displayRightArrow: true,
        formData: { //保存表单
          plan: '',
          cv_lang: "cn", //语言类型
          industry: 'bank', //目标行业
          change_profession: false, //是否转行
          urgency: '', //加急系数
          coupon_id: '', //优惠券id
          cv_optimization: true, //简历优化
          interview_guidance: false, //面试辅导
          interview_simulation: false, //面试模拟训练
          career_plan: false, //职业规划
          resume_submission: false, //简历代投
          discount_monthly_card: false, //特惠月卡
          // professional_test: false, //专业测试
          defect_repair: false, //职业经历瑕疵修复
          custom_industry: '', //自定义求职目标行业
          degree: 'undergraduate', //最高学历
          mentor_type: '', //导师类型
          cv_id: '', //选择中文简历
          cv2_id: '', //选择英文简历
          cn_cv_options:'', //选择中文简历
          en_cv_options: '', //选择英文简历
          job_identity: '', //求职身份
          // phone:'',
        },
        newsData: { //页面下拉菜单数据
          change_profession: [{ //是否转行（实习版、校招版显示文案为“是否跨专业求职”）
            value: '是',
            name: true,
          }, {
            value: '否',
            name: false,
          }],
          defect_repair: [{ //职业经历瑕疵修复
            value: '需要',
            name: true,
          }, {
            value: '不需要',
            name: false,
          }],
          ch_resume:'', //选择中文简历
          en_resume: '', //选择英文简历
        },
        coupons: [], //优惠券列表
        coupon: {}, //优惠券 id
        partner: '', //优惠券-输入框
        loading: false,
        newsShowIndex: 0,
        rules: {
          industry: [
            {validator: validateIndustry, trigger: 'change'}
          ],
        },
        money:-1, //订单money
        getMoneyName:null, //是否正在获取钱的状态
        couponsPrice: '0.00', // 优惠券优惠的价格
        addIndustryState: false, //添加自定义目标行业
        snameState: false, //添加目标行业
        isShowPay: false, //显示订单支付弹窗
        orderId: "", //订单token,
        totalPrice: 0, // 未打折优惠时的订单价格
        originPrice: 0, //未打折之前的价格
        serviceBanner: '', // 服务banner
        cardDetailInfo: null, // 导师卡片详情
      }
    },
    created() {
     //console.log(this.cv_lang_name)
      this._c_t = get_tUser().c_t || '';
      //修改高亮位置
      this.$store.dispatch('app/setNavbarAction', '简历修改');

      this.formData.plan = this.$route.query.plan || ''; 
      //检查是否登录
      if (!this._c_t) {
        //未登录
        routerTo('/signin?type=login')
        return false;
      }
      this.fetchMentorCardDetail()
      // 获取数据
      this.getData();
      // 获取banner
      this.getBanner()
    },
    methods: {
      handleClickArrow(type) {
        if (type === 'left') {
          this.listTranslateX = 0;
          this.displayRightArrow = true;
        } else {
          this.listTranslateX = -486;
          this.displayRightArrow = false;
        }
      },
      success(flag,phone) {
        //console.log(flag)
        this.flag = true
        this.formData.phone = phone;
      },
      serviceBannerClick() {
        if (this.serviceBanner.link) {
          window.open(this.serviceBanner.link, '_blank')
        }
      },
      async getBanner() {
        let res = await api.jobs.getBanner({position: 88})
        if(res.code == 1000) {
          this.serviceBanner = res.data[0]
        }
      },
      async getCouponId (id,coupons) {
        if(coupons){
          this.coupons.unshift(coupons)
        }
        //  console.log(id)
        this.coupons.forEach((element,index) => {
          if(element.id == id) {
            // this.totalPrice = 0
            this.formData.coupon_id = id
            this.coupon.id = id
            this.coupon.index = index
          }
        });
      },
      async fetchMentorCardDetail() {
        try {
          let res = await api.mentor.getMentorCardDetail(this.$route.query.mentor)
          if (res.code === 1000) {
            this.cardDetailInfo = res.data
          }
        } catch(err) {
          console.log(err)
        }
      },
      //获取页面信息
      getData() {
        let { plan } = this.formData;
        api.mentorOrders.mentorOrdersNew({plan: plan}).then(res => {
          if (res.code === 1000) {
            // res.data.faq_items[0].showDescription = true
            this.newsData = {
              ...this.newsData,
              ...res.data
            };
            // 已有手机号跳过手机号验证
            // if (this.newsData.phone) {
            //   this.success('', this.newsData.phone)
            // }
            let {coupons, urgency, degree, price, cn_cv_options, en_cv_options} = res.data;
             this.coupons = coupons;

            if (coupons.length > 0) {

              this.formData.coupon_id = coupons[0].id;
              this.coupon = {
                id: coupons[0].id,
                index: 0
              }
            }
            this.price = price / 100;
             //中文简历
            this.formData.cn_cv_options = cn_cv_options.length ? cn_cv_options[0].name : ''
            //英文简历
            this.formData.en_cv_options = en_cv_options.length ? en_cv_options[0].name : ''

            // 简历语言
            // this.formData.cv_lang = cv_lang[0].name;
            //默认中文简历第一个
            // this.formData.cv_id = cn_cv_options.length ? cn_cv_options[0].value : '';
            // 是否加急
            this.formData.urgency = urgency[0].name;
            this.formData.degree = degree[0].name;
          }
        })
        .catch(err => {
        })
      },
      // 判断formData中指定key为true，其他keys为false
      checkSingleTrue(keysToCheck, allKeys) {
        return keysToCheck.some(key => {
          return this.formData[key] && allKeys.every(k => {
            if (keysToCheck.includes(k)) {
              return true
            }
            return !this.formData[k]
          })
        })
      },
      // 切换服务类型
      toggleService(type) {
        if (!type) {
          return
        }
        this.formData[type] = !this.formData[type];

        if (this.formData.discount_monthly_card) {
          INCOMPATIBLE_KEYS.forEach(key => {
            this.formData[key] = key === type
          })
        }

        if (INCOMPATIBLE_KEYS.includes(type)) {
          this.formData.discount_monthly_card = false
        }

        if (this.disabledOtherService) {
          this.formData.urgency = 'normal'
          this.formData.change_profession = false
          this.formData.degree = 'undergraduate'
        }

        if (!this.formData.cv_optimization || this.disabledOtherService) {
          this.formData.cv_lang = 'cn'
        }

        const resetResumePicker = ['cv_optimization', 'resume_submission', 'discount_monthly_card'].every(key => !this.formData[key])

        //如果没有选择简历优化，清空简历语言
        if(resetResumePicker) {
          this.formData.cv_lang = null
        }
      },
      toPageAnchorPoint() {
        const anchorPoint = document.querySelector('.service-picker')
        if (anchorPoint) {
          const {top} = anchorPoint.getBoundingClientRect()
          window.scrollTo({
            top: top - 30,
            behavior: 'smooth'
          })
        }
      },
      //立即购买
      formSubmit(formName) {
        const resetResumePicker = ['cv_optimization', 'resume_submission', 'discount_monthly_card'].some(key => this.formData[key])
        if(!this.needGetMoney){
          this.$message.error('请选择服务内容')
          return
        }
        this.$refs[formName].validate(async (valid) => {
          if (!valid) {
            return false;
          }
          if (!this.formData.industry) {
            this.$message.error('请选择目标行业')
            return false;
          }
          if (!this.formData.job_identity && this.formData.job_identity !== 0) {
            this.$message.error('请选择求职身份')
            this.toPageAnchorPoint()
            return false;
          }
          if (resetResumePicker) {
            if(!this.formData.cv_lang){
              this.$message.error('请选择简历语言')
              return false;
            }
          }else{
            this.formData.cv_lang = null
          }
          let param = JSON.parse(JSON.stringify(this.formData))
          
          if(!param.degree){
            param.degree = 'undergraduate'
          } 

          if (this.$route.query.mentor) {
            param.mentor_card_id = +this.$route.query.mentor;
          }

          let p = this.getNewOrderParam(param) 
          param.price_params = p

          this.orderReq = JSON.parse(JSON.stringify(param));
              
          api.mentorOrders.mentorOrdersCreate(param).then(res => {
            let {data: {order_token}, code} = res
            //console.log(res,this.formData)
            if (res.code === 1000) {
              // this.coupons.splice(this.coupon.index,1)
              //console.log(this.coupon.index,this.coupons)
              this.orderId = order_token
              // window.location.href=`${window.location.origin}/orders/${res.data.order_token}`
              this.isShowPay = true
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(err => {
            //console.log(err)
            this.$message.error('cateac'+err)
          })

        });
      },
      //下拉框更新数据
      optionChange() {
        let {industry} = this.formData;
        if (industry === 'other') {
          this.formData.custom_industry = '';
          this.toggleServiceBg('addIndustryState')
        }
      },
      //是否显示描述
      toggleDescription(index) {
        let item = JSON.parse(JSON.stringify(this.SERVICE_FAQ[index]));
        item.showDescription = !item.showDescription;
        this.$set(this.SERVICE_FAQ, index, item)
      },
      //切换当前状态
      toggleServiceBg(type) {
        if (this[type]) {
          document.body.style.position = 'initial'
          document.body.style.overflow = 'initial'
        } else {
          document.body.style.position = 'static'
          document.body.style.overflow = 'hidden'
        }
        this[type] = !this[type]
      },
      //电话弹窗
      cancelBindForm(phone){
        this.showBindTips = false;
      },
      // 获取新的价格参数
      getNewOrderParam(param){
        let newparam = {
          basic_service: [],
          special_service: [],
          industry: 9,
          plan: param.plan,
          coupon_id: param.coupon_id,
          channel: 0,
          job_identity: param.job_identity,
          mentor_card_id: this.$route.query.mentor ? +this.$route.query.mentor : undefined
        };
        // 整理基础服务
        ['interview_guidance','interview_simulation','career_plan', 'resume_submission', 'discount_monthly_card'].forEach(key => {
          if(!!param[key]){
            newparam.basic_service.push(key)
          }   
        })
        if(param.cv_optimization) newparam.basic_service.push('cv_optimize')

        // 行业
        let industryServe = {
          'it': 9,
          'finance': 2,
          'advert_media': 5,
          'kuaixiao': 4,
          'tech': 6,
          'buildings': 7,
          'other': 8,
          'bank': 10
        }
        newparam.industry = industryServe[param.industry]
        
        // 特殊服务
        let specialServe = {
          urgency: {rightval: '24hours', value: 'urgency'},
          defect_repair: {rightval: true, value: 'defect_repair'},
          change_profession: {rightval: true, value: 'change_profession'},
          mentor_type: {rightval: 'en', value: 'aboard'},
          cv_lang: {rightval: 'cn_en', value: 'cn_en'},
          degree: {rightval: 'master', value: 'master_degree'}, 
        }
        Object.keys(specialServe).forEach(key => {
          if(param[key] == specialServe[key].rightval) {
            newparam.special_service.push(specialServe[key].value)
          }
        })

        return newparam
      },
      //获取订单价格
      getOrdersPrice(){
        if(!this.needGetMoney){
          return
        }
        clearTimeout(this.getMoneyName);
        this.money = -1;
        this.orderPriceData = {};
        this.getMoneyName = setTimeout(() => {
          console.log('getOrdersPrice=>>',this.formData)
          let param = JSON.parse(JSON.stringify(this.formData))
          // 默认没有海外经历
          if(!param.mentor_type) {
            param.mentor_type = 'cn'
          }
          if(!param.degree){
            param.degree = 'undergraduate'
          }
          let p = this.getNewOrderParam(param)     
          api.mentorOrders.getOrdersPrice(p).then(res=>{
            if(res.code === 1000){
              this.money =  res.data.total_price / 100
              this.originPrice = res.data.origin_total_price / 100
              this.couponsPrice = res.data.coupon_price / 100
              this.orderPriceData = res.data
            }
          })
        }, 500);
        
      },
    },
    components: {
      PcNavbar,
      payMentor,
      bindPhone,
      couponsAlert,
      BlockMentor
    },
    computed: {
      disabledOtherService(){
        return this.checkSingleTrue(INCOMPATIBLE_KEYS2, ALL_KEYS)
      },
      //是否需要获取钱
      needGetMoney(){
        return ALL_KEYS.some(key => this.formData[key])
      },
      ch_resume_id() {
       if(this.newsData.cn_cv_options.length > 0) {
        let {cn_cv_options} = this.formData;
        let options = this.newsData.cn_cv_options;
        let item = options?.filter(item => item.name === cn_cv_options) || []
        return item.length ? item[0].value : ''
       }
       return ''
      },
      en_resume_id() {
        if(this.newsData.cn_cv_options.length > 0) {
        let {en_cv_options} = this.formData;
        let options = this.newsData.en_cv_options;
        let item = options?.filter(item => item.name === en_cv_options) || []
        return item.length ? item[0].value : ''
      }
        return ''
      },
      degree_name() {
        let {degree} = this.formData;
        let options = this.newsData.degree;
        let item = options?.filter(item => item.name === degree) || []
        return item.length ? item[0].value : ''
      },
      mentor_type_name() {
        let {mentor_type} = this.formData;
        let options = this.newsData.mentor_type;
        let item = options.filter(item => item.name === mentor_type) || []
        return item.length ? item[0].value : ''
      },
      cv_lang_name() {
        let {cv_lang} = this.formData;
        let options = this.newsData.cv_lang;
        let item = options ? options?.find(item => item.name === cv_lang) : []
        return item ? item.value : ''
      },
      industry_name() {
        let {industry} = this.formData;
        let options = this.newsData.industry;
        let item = options?.filter(item => item.name === industry) || []
        return item.length ? item[0].value : ''
      },
      
      //是否显示划线价格
      del_price(){
        let {cv_optimization,interview_guidance,interview_simulation,career_plan,resume_submission,discount_monthly_card}=this.formData
        const newArr=[cv_optimization,interview_guidance,interview_simulation,career_plan,resume_submission,discount_monthly_card];
        const delPrice =[]
        newArr.forEach((item)=>{
          if(item) delPrice.push(item);
        })
        if(delPrice.length>=2) return true;
        return false
      },


    },
    filters: {
      jobIdentityFilter(value) {
        return JOB_IDENTITY_OPTIONS.find(item => item.value === value)?.label || ''
      }
    },
    watch: {
      'formData': {
        handler:function() {
          this.getOrdersPrice();
        },
        deep: true    //深度监听
      }
    }
  }
</script>
<style lang="scss" scoped>
  // 公共初始化样式
  @import '~/assets/css/public';
  @import './index.scss';
</style>
<style lang="scss">
  .orderCreate {
    .el-form-item {
      margin-bottom: 0;
    }

    .content{
      .w340{
        border-radius: 2px;
        overflow: hidden;
      }
    }

    .el-form-item__error {
      margin-top: -18px;
    }
    .margin {
      margin-right: 30px;
    }
    .newChangeCss {
      margin-top: 5px;
      line-height: 22px;

      span {
        display: inline-block;
        font-size: 14px;
        font-weight: 400;
        color: #FF4F4C;
        line-height: 14px;
      }
    }
  }
</style>
